import { Component, ViewEncapsulation } from '@angular/core';
import { DcBaseComponent } from '@datachain/ui-sdk/common';

/**
 * Dev-only shell around the SDK cache inspector: the inspector brings its own
 * refresh / clear / evict controls, this only gives it the modal chrome.
 */
@Component({
	selector: 'app-cache-inspector-popup',
	templateUrl: './cache-inspector-popup.component.html',
	styleUrls: ['./cache-inspector-popup.component.scss'],
	// Les styles doivent atteindre l'interieur du composant SDK : tout est
	// porte par la classe du popup, rien ne fuit ailleurs.
	encapsulation: ViewEncapsulation.None,
})
export class CacheInspectorPopupComponent extends DcBaseComponent {
	public constructor() {
		super();
		this.cmpId = 'cache-inspector-popup';
	}
}
